import { abyssColors } from '@/theme/colors';
import { Stack, Skeleton } from '@mui/material';

const AccordionSkeleton = ({ open }: { open?: boolean }) => {
  return (
    <Stack>
      <Stack
        width="100%"
        height="5.6rem"
        justifyContent="center"
        sx={{ background: abyssColors.primary[50], padding: '1.6rem 4rem' }}
      >
        <Skeleton
          variant="rectangular"
          width="20rem"
          height="2rem"
          animation="wave"
          sx={{ borderRadius: '0.4rem', background: 'transparent' }}
        />
      </Stack>
      {open && (
        <Stack
          width="100%"
          height="20rem"
          padding="4rem"
          direction="row"
          justifyContent="space-between"
          sx={{
            border: `0.1rem solid ${abyssColors.primary[100]}`,
            borderRadius: '0 0 0.8rem 0.8rem',
            borderTop: 0,
          }}
        >
          {Array.from({ length: 2 }, (_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width="50%"
              height="100%"
              animation="wave"
              sx={{ borderRadius: '0.4rem', background: 'transparent' }}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export const OverviewSkeleton = () => {
  return (
    <Stack gap="2.4rem" data-testid="overview-skeleton">
      {Array.from({ length: 3 }, (_, index) => (
        <AccordionSkeleton key={index} open={index === 0} />
      ))}
    </Stack>
  );
};
